const DATA_LAYER = window.dataLayer || [];
const GTM_MALT_CUSTOM_EVENT_NAME = 'tracking-malt';

const BASE_EVENT_DEFINITION = {
    event: GTM_MALT_CUSTOM_EVENT_NAME,
};

export function mixin(Hop) {
    Hop.gtm = Hop.gtm || {};

    Hop.gtm.push = (eventDef) => {
        DATA_LAYER.push(Object.assign(BASE_EVENT_DEFINITION, eventDef));
    };

    Hop.gtm.utils = {
        eventName: GTM_MALT_CUSTOM_EVENT_NAME,
    };
}
